var ticket_progress_bar = null
var ticket_via_mail_button = null
document.addEventListener("turbolinks:load", function() {
  tooltip()
  ticket_progress_bar = document.getElementById("ticket_progress_bar");
  get_active_section()
  get_ticket_via_mail()
  if( document.getElementById('instruction_text_step_2')){
    set_text_step2_for_device()
  }
})

function tooltip(){
  $(function () {
    $('[data-toggle="tooltip"]').tooltip()
  })
}

function get_active_section(){
  var product_container = document.getElementById("product_container");
  var payment_form_container = document.getElementById("payment_form_container");
  var payment_success_container = document.getElementById("payment_success_container");
  if(product_container){
    set_product_section()
  } else if (payment_form_container) {
    set_payment_section()
  } else if (payment_success_container) {
    set_get_ticket_section()
  }
}

function get_ticket_via_mail(){
  if ( $('#ticket_via_mail_button' ) ){
    ticket_via_mail_button = $('#ticket_via_mail_button');
    var ticket_via_mail_div = $('#ticket_via_mail_div');
    if (ticket_via_mail_button.length > 0) {
      ticket_via_mail_button.on("click", function(){
        if ( ticket_via_mail_div.style.display == 'none' ){
          ticket_via_mail_div.style.display = 'block';
          ticket_via_mail_div.scrollIntoView();
        } else {
          ticket_via_mail_div.style.display = 'none';
          $('#email_text').scrollIntoView();
        }
      })
    }
  }
}

function set_text_step2_for_device(){
  if(check_for_mobile() == false){
    document.getElementById('qr_code_text_step_2').classList.remove('d-none');
    document.getElementById('download_link').classList.add('d-none');
  } else{
    document.getElementById('instruction_text_step_2').classList.remove('d-none');
  }
}

function check_for_mobile(){
  var isMobile = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
  };
  if( isMobile.any() ){
    return isMobile;
  }else {
    return false;
  }
}

function set_product_section(){
  if (ticket_progress_bar) {
    ticket_progress_bar.style.width = "0%";
  }
}

function set_payment_section(){
  if (ticket_progress_bar) {
   ticket_progress_bar.style.width = "50%";
  }
}

function set_get_ticket_section(){
  if (ticket_progress_bar) {
    ticket_progress_bar.style.width = "100%";
  }
}
